export default {
  inject: {
    elFormItem: {
      default: () => ({ onFieldChange () {} })
    }
  },
  methods: {
    fieldChange () {
      this.elFormItem.onFieldChange()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/el-field-change.js